import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/invoices/{invoiceId}/payment-plans/{paymentPlanId}']['DELETE'];
type Input = ThisApi['query'] & ThisApi['params'];

const deleteInstallment = async ({ invoiceId, paymentPlanId, differenceAction, paymentPlanPaymentId }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.delete(`/invoices/${invoiceId}/payment-plans/${paymentPlanId}`,{ params: { differenceAction, paymentPlanPaymentId }});
  return response.data;
};

export default deleteInstallment;
